import * as React from "react";
import styled, { css } from "styled-components";
import { LinkContainer } from "components/common";
import NavItemStateIndicator, {
  hoverIndicatorStyles,
  activeIndicatorStyles
} from "components/common/NavItemStateIndicator";
import { ButtonToolbar, Button } from "components/bootstrap";
const Container = styled(ButtonToolbar)`
  margin-bottom: 10px;
`;
const StyledButton = styled(Button)(
  ({ theme }) => css`
  font-family: ${theme.fonts.family.navigation};
  font-size: ${theme.fonts.size.navigation};
  color: ${theme.colors.text.primary};
  
  &:hover,
  &:focus {
    background: inherit;
    text-decoration: none;
  }

  &:hover {
    color: inherit;
    ${hoverIndicatorStyles(theme)}
  }

  &.active {
    color: ${theme.colors.text.primary};

    ${activeIndicatorStyles(theme)}

    &:hover,
    &:focus-visible {
      ${activeIndicatorStyles(theme)}
    }
`
);
StyledButton.displayName = "Button";
const NavTabs = ({ items }) => /* @__PURE__ */ React.createElement(Container, null, items.map(({ path, description, exactPathMatch, BadgeComponent }) => /* @__PURE__ */ React.createElement(LinkContainer, { to: path, relativeActive: !exactPathMatch, key: path }, /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "transparent", showOverflow: true }, /* @__PURE__ */ React.createElement(NavItemStateIndicator, null, BadgeComponent ? /* @__PURE__ */ React.createElement(BadgeComponent, { text: description }) : description)))));
export default NavTabs;
